// src/labels.js — how a stored value is written when a person reads it.
//
// Statuses are stored the way the database wants them: lower case, underscores,
// sometimes a vendor's own vocabulary. They were being rendered straight into
// chips and tables, so the console showed "pre_adverse_action" and "needs_info"
// on screens about real people.

const ACRONYMS = new Set([
  'ai', 'sms', 'otp', 'pin', 'ach', 'url', 'id', 'pdf', 'fcra', 'ssn', 'api', 'kyc', 'vto',
]);

const SPECIAL = {
  needs_more_info: 'Needs more information',
  all: 'All',
  pre_adverse_action: 'Pre-adverse notice sent',
  post_adverse_action: 'Final adverse notice sent',
  in_progress: 'In progress',
  on_hold: 'On hold',
  stripe_connect: 'Stripe Connect',
  bank_account: 'Bank account',
  ach: 'ACH',
  in_house: 'In house',
  eligible: 'Eligible',
  blocked: 'Blocked',
  paused: 'Paused',
  not_sent: 'Not sent',
  requires_action: 'Requires action',
  requires_capture: 'Requires capture',
  past_due: 'Past due',
  no_account: 'No account',
  account_closed: 'Account closed',
  insufficient_funds: 'Insufficient funds',
  debit_not_authorized: 'Debit not authorised',
  needs_info: 'Needs information',
  pin: 'PIN',
};

/** The buttons on the stylist approval queue, as instructions rather than enum values. */
export const ACTION_LABELS = {
  under_review: 'Mark under review',
  approve: 'Approve',
  request_info: 'Request information',
  reject: 'Reject',
  suspend: 'Suspend',
  unpublish: 'Unpublish',
  publish: 'Publish',
  reactivate: 'Reactivate',
};

/** "needs_more_info" -> "Needs more information"; "Cancelled by Client" unchanged. */
export function prettyStatus(value) {
  const raw = String(value ?? '').trim();
  if (!raw) return '';
  const key = raw.toLowerCase();
  if (SPECIAL[key]) return SPECIAL[key];
  // Already written for a reader — leave it alone rather than re-casing it.
  if (/[A-Z]/.test(raw) && !raw.includes('_')) return raw;
  return raw
    .replace(/_/g, ' ')
    .split(' ')
    // "ai_daily_limit" read as "Ai daily limit" until these were spelled out.
    .map((w, i) => (ACRONYMS.has(w.toLowerCase())
      ? w.toUpperCase()
      : (i === 0 ? w.replace(/^./, (c) => c.toUpperCase()) : w)))
    .join(' ');
}
